<template>
  <BaseDialog
    title="Status Change"
    v-model="openTicketStatusDialog"
    height="30vh"
    width="30vw"
    cardTextClass="pa-3 ma-0"
    :btnEnable="true"
  >
    <template #information>
      <v-form v-model="isTicketStatusFormValid" ref="TicketStatusForm">
        <v-row class="ma-0">
          <v-col cols="12">
            <SelectField
              id="status"
              v-model="ticketDetails.status"
              :itemsList="itemPriorityList"
              name="status"
              itemText="display_value"
              label="select Status"
              :required="true"
              :rules="[(v) => !!v || 'status is required']"
              :error-messages="formErrors.status"
              @input="delete formErrors.status"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #action>
      <v-btn
        id="ticketStatusSubmit"
        class="primary text-capitalize"
        @click="submitTicketStatusForm"
        :disabled="!isTicketStatusFormValid"
      >
        submit
      </v-btn>
    </template>
  </BaseDialog>
</template>
<script>
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import { bus } from "@/main";
export default {
  components: { BaseDialog },
  props: {
    value: Boolean,
    id: {
      required: true,
    },
    itemPriorityList: {
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      ticketDetails: {},
      formErrors: {},
      isTicketStatusFormValid: false,
      ticketPriorityList: [],
    };
  },
  computed: {
    openTicketStatusDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    openTicketStatusDialog(val) {
      if (val) {
        // this.getSupportOptions();
      } else {
        this.$refs.TicketStatusForm.reset();
        this.ticketDetails = {};
      }
    },
  },
  methods: {
    submitTicketStatusForm() {
      this.$api.supportUserTicket
        .updateTicketStatus({
          id: this.id,
          data: this.ticketDetails,
        })
        .then(() => {
          bus.$emit("showLoader", false);
          this.ticketDetails = {};
          this.openTicketStatusDialog = false;
          this.$emit("getList");
          bus.$emit("showToastMessage", {
            message: "Ticket information updated!",
            color: "success",
          });
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          this.formErrors = err.data;
        });
    },
    getStatusList(data) {},
  },
};
</script>
